module.exports = {
      id: "float-share-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#float-share-usage",
      toString: function () {
        return this.url;
      }
    }